import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet'
import { TextField } from '@material-ui/core';
import { useForm } from "react-hook-form/dist/index.ie11";

import * as UIActions from '../../actions/uiAction';
import * as UserActions from '../../actions/userAction';

const Login = ({ login, UiStore, history }) => {
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const { register, handleSubmit, errors } = useForm({ mode: 'onChange' });

  const onSubmit = async (data) => {
    const success = await login(data)
    if (success) {
      if (UiStore.navToCart)
        history.push('/cart')
      else
        history.push('/')
    }
  }

  return (
    <Fragment>
      <Helmet>
        <title>QBank Login Page</title>
        <meta name="description" content="QBank Sign Up Page allowed existing user to login to their user account with user email and password." />
      </Helmet>
      <div className="loginPage">
        <div className="qbCard">
          <div className="fTitle">KAPTEST USER LOGIN</div>
          <form className="qbForm" onSubmit={handleSubmit(onSubmit)}>
            <div className="itemCont">
              <TextField
                inputRef={register({ required: "Please enter email", pattern: { value: emailRegex, message: "Invalid Email Format" } })}
                id="email"
                name="email"
                label="Email"
                error={!!errors.email}
                helperText={errors.email && errors.email.message}
                required
                fullWidth
                InputProps={{
                  style: { fontSize: 15 }
                }}
                InputLabelProps={{
                  style: { fontSize: 15, color: 'rgba(0, 0, 0, 0.25)' }
                }}
                FormHelperTextProps={{
                  style: { fontSize: 13 }
                }}
              />
            </div>
            <div className="itemCont">
              <TextField
                inputRef={register({ required: "Please enter password", minLength: { value: 6, message: "Password must be longer" } })}
                id="password"
                name="password"
                type="password"
                label="Password"
                error={!!errors.password}
                helperText={errors.password && errors.password.message}
                required
                fullWidth
                InputProps={{
                  style: { fontSize: 15 }
                }}
                InputLabelProps={{
                  style: { fontSize: 15, color: 'rgba(0, 0, 0, 0.25)' }
                }}
                FormHelperTextProps={{
                  style: { fontSize: 13 }
                }}
              />
            </div>
            <div className="actionCont">
              <button className={"qbBtn solid active"} type="submit">LOGIN</button>
              <button className="qbBtn" onClick={() => history.push('/forgot-password')}>Forgot Password?</button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  )
}

const mapStateToProps = ({ UiStore }) => ({
  UiStore
});

const mapDispatchToProps = (dispatch) => ({
  addError: (msg) => dispatch(UIActions.addError(msg)),
  showSuccess: (msg) => dispatch(UIActions.showSuccess(msg)),
  updateNavToCart: (type) => dispatch(UIActions.updateNavToCart(type)),
  login: (data) => dispatch(UserActions.login(data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));


// WEBPACK FOOTER //
// ./src/Components/login/Login.js